import { ArrayField, CustomFieldsSchema, FieldSchema } from "../types";

export const getIsArrayField = (field: FieldSchema | CustomFieldsSchema): field is ArrayField => field.type === "array";
